import { CONSTANTS } from '@/types/enum/constants'

const getIsPharmacyManager = (loggedUserRoles: string[]): boolean => {
  if (!loggedUserRoles) return false
  return loggedUserRoles.includes(CONSTANTS.ROLE_DYNAMIC_OWNER_PHARMACY)
}

export default getIsPharmacyManager
